import { v4 } from 'uuid'
import { saveAs } from 'file-saver'

import { useRef } from 'react'
import { useRequest, useReactive } from 'ahooks'

import { Upload, Image, Col } from 'antd'
import { ProForm, ProFormItem } from '@ant-design/pro-form'

function UploadButton(props) {
  const states = useReactive({ focus: null })

  let count = 1

  let {
      value
    , max
    , upload
    , readonly
    , onSave
    , onChange } = props

  const res = useRequest(async data => {
    const result = await Promise.all(data.map(upload)).then(urls => urls.map((url, index) => {
      return {
          url
        , filename: data[index].name
      }
    }))

    if (onSave) {
      await onSave(R.defaultTo([], value).concat(result))
    }

    return R.defaultTo([], value).concat(result)
  }, {
    manual: true,
  })

  const handleDelete = useRequest(data => {
    if (onSave) {
      return onSave(value?.filter(e => e.url != data.url)).then(() => onChange(value?.filter(e => e.url != data.url)))
    }

    else {
      return onChange(value?.filter(e => e.url != data.url))
    }
  }, {
    manual: true,
  })

  if ((R.isNil(value) || R.isEmpty(value)) && readonly) {
    return <div className='text-gray-500'>（暂无图片）</div>
  }

  return <div className='flex items-end'>
    <div className='flex flex-wrap items-start'>
      {value?.map(elm => {
        return <div
          key={elm.url}
          title={elm.name}
          className='relative mb-2 mr-2 w-32 h-32 cursor-pointer p-0.5 border border-solid border-gray-400'
        >
          <section className='h-full'>
            <img
              src={elm.url}
              alt={elm.name}
              className='object-cover h-full w-full'
            />
          </section>

          <section className='absolute top-0 left-0 text-xl flex items-center justify-center space-x-4 w-full h-full opacity-0 transition-opacity duration-300 hover:opacity-90 bg-gray-600'>
            <div
              title='查看'
              className='fa fa-eye fa fa-trash-o transition-color duration-300 text-white hover:text-blue-600'
              onClick={() => Object.assign(states, { focus: elm.url })}
            />

            <div
              title='下载'
              className='fa fa-download fa fa-trash-o transition-color duration-300 text-white hover:text-blue-600'
              onClick={() => saveAs(elm.url, elm.filename)}
            />

            {
              readonly ? null : (
                handleDelete.loading
                  ? <div className='fa fa-circle-o-notch text-white animate-spin'/>
                  : <div title='删除' className='fa fa-trash-o transition-color duration-300 text-white hover:text-red-600' onClick={() => handleDelete.run(elm)}/>
              )
            }
          </section>
        </div>
      })}

      {value?.length >= max || readonly ? null : (
        <Upload
          multiple
          maxCount={max}
          showUploadList={false}
          customRequest={R.identity}
          beforeUpload={(_, files) => {
            if (count >= files.length) {
              res.runAsync(files).then(onChange).finally(() => count = 1)
            }

            else {
              count++;
            }
          }}
        >
          {res.loading ? (
            <div className='mb-2 w-32 h-32 flex flex-col items-center justify-center space-y-2 cursor-wait border border-dashed border-gray-400'>
              <div className='fa fa-spinner animate-spin text-xl'></div>
              <div className='text-gray-400 text-xs'>上传中...</div>
            </div>
          ) : (
            <div className='mb-2 w-32 h-32 flex flex-col items-center justify-center space-y-2 cursor-pointer border border-dashed border-gray-400 hover:border-blue-600 hover:text-blue-600'>
              <div className='fa fa-upload'></div>
              <div>点击上传</div>
            </div>
          )}
        </Upload>
      )}
    </div>

    {states.focus == null ? null : (
      <Image
        className='hidden'
        src={states.focus}
        preview={{ visible: true, scaleStep: 0.6, src: states.focus, onVisibleChange: () => Object.assign(states, { focus: null }) }}
      />
    )}
  </div>
}

function FormItem (props) {
  if (props.colProps) {
    return <Col {...props.colProps}>
      <ProFormItem {...R.omit([ 'help', 'colProps', 'fieldProps' ], props)} label={props.help ? `${props.label}（${props.help}）` : props.label}>
        <UploadButton {...R.omit([ 'onChange' ], props)} {...props.fieldProps} />
      </ProFormItem>
    </Col>
  }

  return <ProForm.Item {...R.omit([ 'help', 'fieldProps' ], props)} label={props.help ? `${props.label}（${props.help}）` : props.label}>
    <UploadButton {...R.omit([ 'onChange' ], props)} {...props.fieldProps} />
  </ProForm.Item>
}

export default Object.assign(FormItem, {
  WithoutFormItem: UploadButton
})
